module.exports = __webpack_public_path__ + "media/site_templates/www.exterminators.net.au/images/testimonials-1304058a2bbd1a094d5ae73a50f8602e.jpg";